import { memo, useMemo } from 'react'
import './index.scss'
import Icon from '../Icon'
import { ICON } from '../Icon/data'
import { COLOR } from '../../data/variables'
import { isValidUrl } from '../../services/utils/validation'

type Image = {
  url?: string
  alt?: string
}

const Image = memo(({ url, alt }: Image) => {
  const isValidImg = isValidUrl(url)

  const image = useMemo(() => {
    if (isValidImg) {
      return (
        <img src={url} alt={alt} />
      )
    }

    return (
      <div className="Image__noimg">
        <Icon icon={ICON.CAMERA} color={COLOR.WHITE} />
      </div>
    )
  }, [url, isValidImg])

  return (
    <div className="Image">
      {image}
    </div>
  )
})

export default Image
